<template>
  <v-layout column>
    <v-flex>
     <span class="headline">
       Agentes
     </span>
    </v-flex>
    <v-flex>
      <v-card>
        <v-card-text class="clickable" @click="$emit('showAgent')">
          <v-layout row>
            <v-flex md6>
              <span class="caption grey--text lighten-2  ml-3">
                Nombre
              </span>
            </v-flex>
            <v-flex class="text-xs-right" md6>
              <span class="caption grey--text lighten-2">
                Por responder
              </span>
            </v-flex>
          </v-layout>
          <vue-perfect-scrollbar :settings="settings">
            <div class="scrollBar">
              <transition name="fade-effect" mode="out-in">
                <skeleton-box flat v-if="isSearching">
                  <skeleton-line v-for="i in 10" :key="`${i}-skeleton-line`" class="custom-line">
                  </skeleton-line>
                </skeleton-box>
                <template v-else>
                  <div>
                    <template v-if="agents.length > 0" >
                      <v-layout v-for="(agent, i) in agents" :key="`agent-${i}`" row>
                        <v-flex md1>
                          <v-icon small class="text-small mr-1 darken-1" :class="[agent.online === 1 ? 'green--text' : 'red--text']" >
                            fas fa-comment-{{ agent.online === 1 ? 'dots' : 'slash'}}
                          </v-icon>
                        </v-flex>
                        <v-flex md8>
                          <span class="body-1">
                            {{agent.first_name}} {{agent.last_name}}
                          </span>
                        </v-flex>
                        <v-flex class="text-xs-right" md3>
                          <span class="body-1">
                            {{agent.unanswered}}
                          </span>
                        </v-flex>
                      </v-layout>
                    </template>
                    <template v-else>
                      <v-layout row h-100 align-center>
                        <v-flex md12 class="text-xs-center">
                          <span class="body-1">
                            No se encontraron usuarios
                          </span>
                        </v-flex>
                      </v-layout>
                    </template>
                  </div>
                </template>
              </transition>
            </div>
          </vue-perfect-scrollbar>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import SkeletonLine from '@/components/global/skeletons/Line';
import SkeletonBox from '@/components/global/skeletons/SkeletonBox';

export default {
  props: {
    channel: {
      type: Object,
      required: true,
    },
  },
  components: {
    VuePerfectScrollbar,
    SkeletonLine,
    SkeletonBox,
  },
  data() {
    return {
      agents: [],
      isSearching: true,
      settings: {
        suppressScrollX: true,
      },
    };
  },
  mounted() {
    this.getData(true);
  },
  methods: {
    startListening() {
      this.channel.listen('.ChangeChatOnlineStatus', (event) => {
        this.changeOnlineStatus(event);
      }).listen('.ChatCenterUpdated', (event) => {
        // eslint-disable-next-line
        if (event.chatCenter.chat_center_status_id === 4 || event.chatCenter.chat_center_status_id_old === 4) {
          let chatCenter = {};
          if (event.chatCenter) {
            chatCenter = event.chatCenter;
          } else {
            chatCenter = event;
          }
          this.changeChatStatus(chatCenter);
        }
      });
    },
    changeOnlineStatus(user) {
      const findIt = this.agents.find(x => x.id === Number(user.id));
      if (findIt) {
        findIt.online = user.chat_center_online;
      } else {
        this.$set(this.agents, this.agents.length, {
          id: Number(user.id),
          first_name: user.first_name,
          last_name: user.last_name,
          unanswered: 0,
          online: user.chat_center_online,
        });
      }
    },
    changeChatStatus(chat) {
      let user = this.agents.find(x => x.id === chat.user_id);
      const userOld = this.agents.find(x => x.id === chat.user_old);
      if (!user) {
        user = this.$set(this.agents, this.agents.length, {
          id: chat.user_id,
          first_name: chat.user.first_name,
          last_name: chat.user.last_name,
          unanswered: 0,
          online: chat.user.chat_center_online,
        });
      }
      if (chat.chat_center_status_id === 4) {
        user.unanswered += 1;
      } else if (user.unanswered > 0 && chat.chat_center_status_id_old === 4) {
        user.unanswered -= 1;
      }
      if (userOld) {
        if (userOld.unanswered > 0 && chat.chat_center_status_id_old === 4) {
          userOld.unanswered -= 1;
        }
      }
    },
    getData(check = false) {
      this.isSearching = true;
      this.axios.get('chat/center/agents').then(({ data }) => {
        for (let i = 0; i < data.length; i += 1) {
          this.$set(this.agents, i, data[i]);
        }
        if (check) {
          this.startListening();
        }
      }).catch(() => {}).then(() => {
        this.isSearching = false;
      });
    },
  },
};
</script>
<style scoped>
.scrollBar {
  height: 22vh;
  width: 95%;
}
.custom-line {
  border-radius: 0 !important;
  margin-bottom: 1vh !important;
  height: 3vh;
}
</style>





// WEBPACK FOOTER //
// src/components/chat_center_v2/dashboard/Agents.vue